import { render, staticRenderFns } from "./SkinTradeableIcon.vue?vue&type=template&id=634bc6d8&scoped=true&"
import script from "./SkinTradeableIcon.vue?vue&type=script&lang=ts&"
export * from "./SkinTradeableIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634bc6d8",
  null
  
)

export default component.exports